import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import Button from '@atlaskit/button/custom-theme-button';
import { internalFooterStyles } from '../styles/content';
export default function ModalFooter(props) {
  const {
    actions,
    appearance,
    component,
    onClose,
    testId
  } = props;
  const warning = 'You can provide `component` OR `actions`, not both.';

  if (!component && !actions) {
    return null;
  }

  if (component && actions) {
    console.warn(warning); // eslint-disable-line no-console

    return null;
  }

  if (component) {
    return /*#__PURE__*/React.createElement(component, {
      appearance,
      onClose
    });
  }

  return jsx("div", {
    css: internalFooterStyles,
    "data-testid": testId && `${testId}--footer`
  }, actions && actions.map(({
    text,
    ...rest
  }, index) => jsx(Button, _extends({
    key: index,
    appearance: index !== 0 ? 'subtle' : appearance || 'primary',
    "data-ds--modal-dialog--action": true,
    testId: testId && `${testId}--action-${index}`
  }, rest), text)));
}